<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { required } from "vuelidate/lib/validators";

export default {
  locales: {
    pt: {
      'Downloads': 'Downloads',
    },
    es: {
      'Downloads': 'Descargas',
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      loading: true,
      errored: false,
      total: 0,
      fields: [
        { key: "code", label: "Código" },
        { key: "value", label: "Valor" },
      ],
      items: null,

      sortBy: "name",
      sortDesc: false,

      create: {
        modal: false,
        loading: false,
        code: "",
        percent: 10,
      },
    };
  },
  validations: {
    create: {
      code: { required },
      percent: { required },
    },
  },
  methods: {
    getCoupons() {
      api
        .get('coupons')
        .then((response) => {
          if (response.data.status == 'success') {
            this.items = response.data.list
          }
        })
        .catch((error) => {
          if (error) {
            this.items = []
          }
        })
    },
    showCreate() {
      this.create.modal = false;
      this.create.modal = true;
    },
    createCoupon() {
      this.$v.create.$touch();
      if (this.$v.create.$invalid) {
        return;
      } else {
        this.create.loading = true;

        api
          .post("coupons", {
            code: this.create.code,
            percent: this.create.percent,
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.create.code = "";
              this.create.percent = 10;
              this.$v.create.$reset();

              this.create.modal = false;
              this.$toast.success('O cupom foi criado com sucesso.');
              this.getCoupons();
            } else {
              this.$toast.error(response.data.message);
            }

            this.create.loading = false;
          })
          .catch(error => {
            if (error) {
              this.create.loading = false;
              this.$toast.error('Ocorreu um erro ao criar o cupom, tente novamente.');
            }
          })
          .finally(() => {
            this.create.loading = false;
          });
      }
    },
    formatCode() {
      this.create.code = this.create.code
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },
  },
  mounted() {
    this.getCoupons();
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Meus Cupons</h3>
        <p></p>
      </div>
    </div>

    <div id="dropdown" class="d-flex mb-4">
      <b-dropdown variant="outline-light">
        <template #button-content>
          ações
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
          </svg>
        </template>
        <b-dropdown-item v-on:click="showCreate()">Criar cupom</b-dropdown-item>
      </b-dropdown>
    </div>

    <div v-if="!items" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="items && items.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          nenhum cupom encontrado
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="table-responsive">
          <b-table :items="items" :fields="fields" class="table-nowrap table-style table-hover" head-variant="light" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive>
            <template #cell(value)="row">
              <template v-if="row.item.type == 'percentage'">{{ row.item.value | points }}%</template>
              <template v-if="row.item.type == 'absolute'">{{ row.item.value | currency }}</template>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <b-modal v-model="create.modal" modal-class="modal-right" hide-header hide-footer>
      <div class="d-flex justify-content-between">
        <h4 class="mb-5">Criar cupom</h4>
        <a class="btn btn-outline-link" v-on:click="create.modal = false;">Fechar <sup>ESC</sup></a>
      </div>
      <b-form @submit.prevent="createCoupon">
        <b-form-group id="create.code" label="Código" label-for="create.code">
          <b-form-input id="create.code" v-model="create.code" type="text" :class="{ 'is-invalid': $v.create.code.$error }" v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXXX'" @input="formatCode"></b-form-input>
          <div v-if="$v.create.code.$error" class="invalid-feedback">
            <span v-if="!$v.create.code.required">O código é obrigatória.</span>
          </div>
        </b-form-group>
        <b-form-group id="create.percent" label="Desconto" label-for="create.percent">
          <b-form-select id="create.percent" v-model="create.percent" :class="{ 'is-invalid': $v.create.percent.$error }">
            <option value="10">10%</option>
            <option value="15">15%</option>
            <option value="20">20%</option>
          </b-form-select>
          <div v-if="$v.create.percent.$error" class="invalid-feedback">
            <span v-if="!$v.create.percent.required">O percentual é obrigatório.</span>
          </div>
        </b-form-group>
        <div class="mt-5 d-flex justify-content-between">
          <b-button :disabled="this.create.loading == true" type="submit" variant="default" class="btn-lg px-4">
            Criar
            <b-spinner v-if="create.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </Layout>
</template>